import { Component, inject } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ButtonComponent, IconButtonComponent } from '@vg-constellation/angular-17/button';
import { SpinnerComponent } from '@vg-constellation/angular-17/spinner';
import { GlobalStateStore } from "@services/global-state/global-state.service";
import * as constants from "../../services/content/content";

@Component({
  selector: 'app-save-status-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, IconButtonComponent, SpinnerComponent],
  templateUrl: './save-status-modal.component.html',
  styleUrls: ['./save-status-modal.component.scss']
})

export class SaveStatusModalComponent {
  // HEYHEY: Anytime you want to update the state/content values on the modal, pass them in through the globalStore's update functions
  readonly globalStore = inject(GlobalStateStore);
  constants = constants;
}
